import logo from './logo.svg';
import './App.css';
import { Provider } from "react-redux";
import store from './redux/store';
import TopBar from './Components/TopBar/TopBar';
import FormDataSelectionRow from './Components/FormDataSelectionRow/FormDataSelectionRow';
import DataTable from './Components/DataTable/DataTable';

function App() {
  return (
    <Provider store={store}>

      <TopBar></TopBar>

      <section>
        <FormDataSelectionRow></FormDataSelectionRow>
        <DataTable></DataTable>
      </section>
    </Provider>
  );
}

export default App;
